var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c(_vm.$route.meta.layout || _vm.layout,{tag:"component"},[_c('router-view')],1),_c('NotificationModal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }